var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// inspired by this library https://github.com/deepsweet/mnth
// it cannot be used directly because of this issue: https://github.com/deepsweet/mnth/issues/2
import { addDays, endOfMonth, getDay, getDaysInMonth, setDate, startOfMonth } from 'date-fns';
var DAYS_IN_WEEK = 7;
var generateMonthGrid = function (date, options) {
    var firstDay = __assign({ firstDay: 1 }, options).firstDay;
    var daysInMonth = getDaysInMonth(date);
    var firstDateOfMonth = startOfMonth(date);
    var lastDateOfMonth = endOfMonth(date);
    var firstDayOfMonth = getDay(firstDateOfMonth);
    var lastDayOfMonth = getDay(lastDateOfMonth);
    var daysToPrepend = (firstDayOfMonth - firstDay + DAYS_IN_WEEK) % DAYS_IN_WEEK;
    var daysToAppend = (DAYS_IN_WEEK - 1 - lastDayOfMonth + firstDay) % DAYS_IN_WEEK;
    var month = [];
    var week = [];
    for (var i = 1 - daysToPrepend; i <= daysInMonth + daysToAppend + 1; i++) {
        if (week.length <= 7) {
            if (i <= 0) {
                week.push(addDays(firstDateOfMonth, i - 1));
            }
            else if (i > daysInMonth) {
                week.push(addDays(lastDateOfMonth, i - daysInMonth));
            }
            else {
                week.push(setDate(date, i));
            }
        }
        if (week.length === 7) {
            month.push(week);
            week = [];
        }
    }
    return month;
};
export default generateMonthGrid;
//# sourceMappingURL=generate-month-grid.js.map